import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateAdapter, MatPaginator, MatSort, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { FiltrosComprobanteIF } from 'app/models/FiltrosComprobanteIF';
import { MessagesTitles, MessagesStatus, MessagesGeneral } from 'app/models/messages';
import { ReportesService } from 'app/services/reportes/reportes.service';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-lista-comprobante-if',
  templateUrl: './lista-comprobante-if.component.html',
  styleUrls: ['./lista-comprobante-if.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListaComprobanteIfComponent {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns = ['Razon_Social', 'Num_Doc_Identificacion', 'Fecha_Emision', 'Moneda', 'Serie', 'Numero', 'Op_Gravada', 'IGV_Importe', 'Total', 'Tipo_Comprobante', 'Referencia', 'Estado'];
  pageSizeOptions = [15, 20, 30, 50, 100, 200];

  dia: number;
  fechaD: Date = new Date();
  fechaH: Date = new Date();

  abrirDetalleComprobante: boolean = false;
  loading: boolean;
  dataSource: any;
  idProvedor: any;
  proveedoresArr: any;

  documentosIF: any = [];
  ruc = new FormControl();
  rucAdq = new FormControl();
  filteredProveeedor: Observable<any[]>;

  DTOFiltrosCompIF: FiltrosComprobanteIF = new FiltrosComprobanteIF();

  constructor(private reporteService: ReportesService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    public datepipe: DatePipe) {
    this.dia = this.fechaD.getDate() - 1;
    this.fechaD.setDate(this.fechaD.getDate() - this.dia);
    this.ObtenerProveedoresCombo();
  }


  tipoMoneda(event) {
    if(event==''){
      this.DTOFiltrosCompIF.Moneda = "0";
    }else{
      this.DTOFiltrosCompIF.Moneda = event;
    } 
  }

  exportToExcel() {
    if (this.documentosIF.length > 0) {
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.documentosIF);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let fecha = new Date().toLocaleString('en-GB');
      XLSX.writeFile(wb, 'Reporte_DocumentosIF_' + fecha + '.xlsx');
    } else {
      Swal.fire({
        title: "Atención",
        text: "No existe información para exportar.",
        type: "info",
        allowOutsideClick: false,
        heightAuto: false
      });
    }

  }

  filtradoCompElectronicos() {
    this.loading = true;
    this.documentosIF = [];
    if (this.ruc.value == null || this.ruc.value == "") {
      this.idProvedor = "0";
      this.DTOFiltrosCompIF.IdProv = "0";
    }
    this.DTOFiltrosCompIF.FechaInicial = this.datepipe.transform(this.fechaD, 'yyyy-MM-dd');
    this.DTOFiltrosCompIF.FechaFinal = this.datepipe.transform(this.fechaH, 'yyyy-MM-dd');

    this.reporteService.ObtenerReporteComprobantesIF(this.DTOFiltrosCompIF).subscribe(
      resp => {
        this.documentosIF = resp
        this.dataSource = new MatTableDataSource(this.documentosIF);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;

      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Lista de Comprobantes IF no obtenida. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    )
  }

  obtenerRucRazSocialProv(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.proveedoresArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idProvedor = p.idEmpresa;
          this.DTOFiltrosCompIF.IdProv = p.idEmpresa;
        }
      }
    }
  }

  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerIdProv(termino: string) {
    this.idProvedor = termino;
    this.DTOFiltrosCompIF.IdProv = termino;
  }

}
